export default __webpack_public_path__ + "static/media/Emmanuel Mathew.57a3d55a.jpg";